export const IN = 'In'
export const OUT = 'Out'
export const INTERNAL = 'Internal'
export const EXTERNAL = 'External'
export const SWAP = 'Swap'
export const IGNORE = 'Ignore'
